import {
  FiGift,
  FiBookOpen,
  FiShoppingBag,
  FiMessageSquare,
  FiVideo,
  FiLink,
  FiCloud,
  FiHeadphones,
} from "react-icons/fi";

/**
 * Same catalog as Mint Space → App Store (marketing / install flows use this list).
 */
export function getMintSpaceAppStoreCatalog(t) {
  return [
    {
      id: "creator-rewards",
      name: t("navigation.creatorRewards"),
      description: t("mintSpace.creatorRewardsDescription"),
      icon: FiGift,
      color: "from-purple-500 to-pink-500",
      glow: "rgba(217,70,239,0.45)",
      category: "growth",
      featured: true,
      isDefault: true,
      comingSoon: false,
    },
    {
      id: "gateway",
      name: t("navigation.gateway"),
      description: t("mintSpace.gatewayDescription"),
      icon: FiLink,
      color: "from-violet-500 to-fuchsia-500",
      glow: "rgba(167,139,250,0.4)",
      category: "tools",
      featured: true,
      comingSoon: false,
    },
    {
      id: "mintly-cloud",
      name: t("navigation.cloud"),
      description: t("mintSpace.cloudDescription"),
      icon: FiCloud,
      color: "from-sky-400 to-blue-600",
      glow: "rgba(56,189,248,0.4)",
      category: "tools",
      comingSoon: false,
    },
    {
      id: "courses",
      name: t("navigation.courses") || "Courses",
      description: t("mintSpace.coursesDescription"),
      icon: FiBookOpen,
      color: "from-blue-500 to-cyan-500",
      glow: "rgba(59,130,246,0.4)",
      category: "education",
      featured: true,
      comingSoon: false,
    },
    {
      id: "shop",
      name: t("mintSpace.appShopName") || "Shop",
      description: t("mintSpace.appShopDescription") || "Sell products, merchandise, and digital goods directly to your community.",
      icon: FiShoppingBag,
      color: "from-orange-500 to-red-500",
      glow: "rgba(249,115,22,0.4)",
      category: "commerce",
      comingSoon: true,
    },
    {
      id: "chat",
      name: t("mintSpace.appChatName") || "Chat",
      description: t("mintSpace.appChatDescription") || "Engage with your community through real-time messaging and group chats.",
      icon: FiMessageSquare,
      color: "from-green-500 to-emerald-500",
      glow: "rgba(16,185,129,0.4)",
      category: "community",
      comingSoon: true,
    },
    {
      id: "consulting",
      name: t("mintSpace.appConsultingName") || "Consulting",
      description:
        t("mintSpace.appConsultingDescription") ||
        "Sell 1:1 consulting — paid chat, voice, and video with your clients.",
      icon: FiHeadphones,
      color: "from-violet-500 to-indigo-600",
      glow: "rgba(139,92,246,0.4)",
      category: "community",
      featured: true,
      comingSoon: false,
    },
    {
      id: "live-stream",
      name: t("mintSpace.appLiveName") || "Live Stream",
      description: t("mintSpace.appLiveDescription"),
      icon: FiVideo,
      color: "from-red-500 to-pink-500",
      glow: "rgba(239,68,68,0.4)",
      category: "community",
      featured: false,
      comingSoon: false,
    },
  ];
}
